export default __webpack_public_path__ + "static/media/destaque1_recorte.0aa0e55b.webp";